
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initPerformanceOptimizations } from './utils/performance.ts'

// Initialisation des optimisations de performance
initPerformanceOptimizations();

// Optimisation du rendu initial
const container = document.getElementById('root');
if (!container) {
  throw new Error('Root element not found');
}

// Création du root avec optimisations
const root = createRoot(container, {
  // Optimisations React 18
  identifierPrefix: 'zeus-',
});

// Rendu avec gestion d'erreurs
try {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  );
} catch (error) {
  console.error('Erreur de rendu:', error);
  // Fallback en cas d'erreur
  container.innerHTML = `
    <div style="
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
      background: #0A0A0A;
      color: #FF8A00;
      font-family: Inter, sans-serif;
      text-align: center;
      padding: 2rem;
    ">
      <div>
        <h1 style="font-size: 2rem; margin-bottom: 1rem;">MAISON ZEUS™</h1>
        <p>Chargement en cours...</p>
        <div style="
          width: 40px;
          height: 40px;
          border: 3px solid #FF8A00;
          border-top: 3px solid transparent;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 1rem auto;
        "></div>
      </div>
    </div>
    <style>
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    </style>
  `;
  
  // Retry après 2 secondes
  setTimeout(() => {
    window.location.reload();
  }, 2000);
}

// Optimisations post-chargement
window.addEventListener('load', () => {
  // Préchargement des ressources critiques
  const criticalImages = [
    'https://static.readdy.ai/image/445bd39afde876450f502e12e8cf89e5/81b291b3f4cfb9cdbfd24b12e38318c8.png'
  ];
  
  criticalImages.forEach(src => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = src;
    document.head.appendChild(link);
  });
  
  // Optimisation des images existantes
  const images = document.querySelectorAll('img:not([loading])');
  images.forEach(img => {
    img.loading = 'lazy';
    img.decoding = 'async';
  });
  
  // Nettoyage des ressources inutiles
  setTimeout(() => {
    const unusedLinks = document.querySelectorAll('link[rel="preload"]:not([data-keep])');
    unusedLinks.forEach(link => {
      if (link.parentNode) {
        link.parentNode.removeChild(link);
      }
    });
  }, 5000);
});

// Gestion des erreurs globales
window.addEventListener('error', (event) => {
  console.error('Erreur globale:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('Promise rejetée:', event.reason);
});

// Optimisation de la visibilité de la page
document.addEventListener('visibilitychange', () => {
  if (document.hidden) {
    // Pause des animations coûteuses quand la page n'est pas visible
    document.documentElement.style.setProperty('--animation-play-state', 'paused');
  } else {
    // Reprise des animations
    document.documentElement.style.setProperty('--animation-play-state', 'running');
  }
});
